module.exports = __webpack_public_path__ + "img/26.80f188c8.png";